// @ts-nocheck
import PushNotificationIOS from '@react-native-community/push-notification-ios';
import {Platform} from 'react-native';
import PushNotification from 'react-native-push-notification';
import {Alert} from '../@types';
import {store} from '../redux/store';
import {
  DEFAULT_NOTIFICATION_SOUND_KEY,
  ensureNotificationChannelForSoundKey,
  resolveNotificationSound,
} from './notificationSounds';

const constructActionTexts = (alert: Alert) => {
  const actions = [];
  if (alert.button1) {
    actions.push(alert.button1.text);
  }
  if (alert.button2) {
    actions.push(alert.button2.text);
  }
  if (alert.button3) {
    if (alert.button3.text === 'Call') {
      if (alert.phoneNumber) {
        actions.push(alert.button3.text);
      }
    } else {
      actions.push(alert.button3.text);
    }
  }
  return actions;
};

const constructIOSActionTexts = (alert: Alert) => {
  const actions = [];

  if (alert.button1) {
    actions.push({
      id: alert.button1,
      title: alert.button1.text,
      // options: {foreground: true},
    });
  }
  if (alert.button2) {
    actions.push({
      id: alert.button2.text,
      title: alert.button2.text,
      // options: {foreground: true},
    });
  }
  if (alert.button3) {
    actions.push({
      id: alert.button3.text,
      title: alert.button3.text,
      // options: {foreground: true},
    });
  }

  const category = [
    {
      id: 'userActions',
      actions,
    },
  ];
  return category;
};

const buildData = alert => {
  const actions = {};
  let data = {};

  if (alert.button1) {
    var key = alert.button1.text;
    actions[key] = parseInt(alert.button1.value, 10);
  }
  if (alert.button2) {
    var key = alert.button2.text;
    actions[key] = parseInt(alert.button2.value, 10);
  }
  if (alert.button3) {
    var key = alert.button3.text;
    if (alert.button3.text === 'Call') {
      if (alert.phoneNumber) {
        actions[key] = parseInt(alert.button3.value, 10);
      }
    } else {
      actions[key] = parseInt(alert.button3.value, 10);
    }
  }
  data = alert?.data;
  // data.actions = actions;
  // delete data?.sender?.image;
  return data;
};

const recentNotificationsCache = new Map<string, number>();
const CACHE_EXPIRY_MS = 8000; // 8 seconds suppression window

export async function sendNotification(alert, id) {
  const message = alert.message || '';
  const now = Date.now();

  // Clean up expired cache entries
  for (const [cachedMsg, timestamp] of recentNotificationsCache.entries()) {
    if (now - timestamp > CACHE_EXPIRY_MS) {
      recentNotificationsCache.delete(cachedMsg);
    }
  }

  if (message) {
    const lastSentTime = recentNotificationsCache.get(message);
    if (lastSentTime && (now - lastSentTime < CACHE_EXPIRY_MS)) {
      console.log(`[Notification] Ignoring duplicate drawer notification within time window: "${message}"`);
      return;
    }
    recentNotificationsCache.set(message, now);
  }

  // const actionTexts = constructActionTexts(alert);
  // const imageUrl = alert.sender.image
  //   ? `data:image/jpeg;base64,${alert.sender.image}`
  //   : null;

  if (Platform.OS === 'ios') {
    PushNotificationIOS.setNotificationCategories(
      constructIOSActionTexts(alert),
    );
  }

  const selectedSoundKey =
    store.getState()?.notificationSound?.selectedSoundKey ??
    DEFAULT_NOTIFICATION_SOUND_KEY;
  const selectedSound = resolveNotificationSound(selectedSoundKey);

  await ensureNotificationChannelForSoundKey(selectedSoundKey);

  let notifObject = {
    channelId: selectedSound.channelId,
    channelName: selectedSound.label,
    ticker: 'My Notification Ticker',
    autoCancel: true,
    // largeIcon: imageUrl,
    // largeIconUrl: imageUrl,
    // bigPictureUrl: imageUrl,
    smallIcon: '',
    subText: `New alert from ${
      'unit' + alert?.data?.unit?.unitName || 'Asterix Community App'
    }`,
    color: 'blue',
    vibrate: true,
    vibration: 300,
    tag: alert.alertId, //Notification Id
    group: 'group',
    groupSummary: false,
    ongoing: false,
    priority: 'high',
    importance: 'high',
    visibility: 'public',
    ignoreInForeground: false,
    shortcutId: 'shortcut-id',
    onlyAlertOnce: false,

    when: Date.now(),
    showWhen: true,
    timeoutAfter: null,
    messageId: 'google:message_id',

    // actions: actionTexts,
    invokeApp: true,

    playSound: true,
    soundName: selectedSound.soundName,

    title: alert.eventName || 'New Alert',
    message: alert.message,
    data: buildData(alert),
    userInfo: buildData(alert),
    category: 'userActions',
  };

  if (id) {
    notifObject = {
      ...notifObject,
      id: id,
    };
  }

  if (alert.eventName === 'RequestAccess' || alert.eventName === 'UnitLink') {
    notifObject = {
      ...notifObject,
      actions: [],
    };
  }
  PushNotification.localNotification(notifObject);
}
